var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5003 29.3334C37.2337 29.3334 37.8337 29.9334 37.8337 30.6667V36.0001C37.8337 36.7334 37.2337 37.3334 36.5003 37.3334C35.767 37.3334 35.167 36.7334 35.167 36.0001V30.6667C35.167 29.9334 35.767 29.3334 36.5003 29.3334ZM36.487 22.6667C29.127 22.6667 23.167 28.6401 23.167 36.0001C23.167 43.3601 29.127 49.3334 36.487 49.3334C43.8603 49.3334 49.8337 43.3601 49.8337 36.0001C49.8337 28.6401 43.8603 22.6667 36.487 22.6667ZM36.5003 46.6667C30.607 46.6667 25.8337 41.8934 25.8337 36.0001C25.8337 30.1067 30.607 25.3334 36.5003 25.3334C42.3937 25.3334 47.167 30.1067 47.167 36.0001C47.167 41.8934 42.3937 46.6667 36.5003 46.6667ZM37.8337 42.6667H35.167V40.0001H37.8337V42.6667Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlue);
export default __webpack_public_path__ + "static/media/IconInfoBlue.14c8455ce95e733ed25929e42e5e3f9e.svg";
export { ForwardRef as ReactComponent };